import { Panel } from '@/components/ui'
import { T } from '@/lib/theme'

/// The shared "nothing here (yet)" panel, so a bare-bones / pre-launch / wrong-network state reads
/// as intentional rather than broken. Same shape the Vaults page established: a centred title + a
/// calm one-line explanation, never an error. Used by every product page's not-live gate so they
/// blank out consistently until Horizon is actually deployed on the connected network.
export function EmptyState({ title, body }) {
  return (
    <Panel elevated style={{ padding: 40, textAlign: 'center' }}>
      <div style={{ color: T.textMuted, fontFamily: T.fontM, fontSize: T.fs.ui, fontWeight: 700 }}>{title}</div>
      {body && (
        <div style={{ marginTop: 8, color: T.textDim, fontFamily: T.fontM, fontSize: T.fs.body, lineHeight: 1.6 }}>{body}</div>
      )}
    </Panel>
  )
}
